import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { SharedComponentService } from "../../shared-component.service";
import { GlobalService } from "../../../global/global.service";
import { FamiliesCommunitiesFormService } from "../../../families-communities-form/families-communities-form.service";

@Component({
  selector: 'app-educator-registration-view',
  templateUrl: './educator-registration-view.component.html',
  styleUrls: ['./educator-registration-view.component.sass']
})
export class EducatorRegistrationViewComponent implements OnInit {

  @Input() rowRef: string;
  @Input() headerHide: number = 0;
  @Input() notificationRef: string = '';
  @Output() closeModal = new EventEmitter<boolean>();
  data: any = [];
  loggedUser: any = [];
  signatureImg = null;
  currentDate = null;
  isNewSignature = true;
  isEdit = false;
  submitted = false;
  error = '';
  sigError = false;
  allMembers: any = [];
  selectedChildren: any = [];
  children: any = [];
  signatureLength = 0;
  currentIndex: any = -1;
  htmlBody = null;

  constructor(
    private shardService: SharedComponentService,
    private fb: FormBuilder,
    private globeService: GlobalService,
  ) {
    this.loggedUser = JSON.parse(localStorage.getItem('user'));
  }

  ngOnInit(): void {
    this.getNotification();
  }

  getNotification() {
    this.shardService.getEducatorRegistrationForm(this.rowRef).subscribe(res => {
      this.data = res['data'];
    }, error => {
      this.globeService.showErrorNotification(error.statusText);
    });
  }

  modalClose() {
    this.closeModal.emit(true);
  }

}
